module.exports = __webpack_public_path__ + "img/touxiang.775bae1a.png";